import React, { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { draggable } from '@atlaskit/pragmatic-drag-and-drop/element/adapter'
import { Truncate } from '@re-dev/react-truncate'
import _ from 'lodash'

import { PROFILE_PAGE } from 'utils/paths'
import { getDeadlineState, getNextDeadlinesFromPrograms } from 'components/Deadlines/helpers'
import { getPipelines } from 'store/actions/pipeline'
import { selectIsCardUpdating } from 'store/selectors/pipelineCards'
import CardActions from 'components/CardActions'
import HideCardAction from 'components/CardActions/actions/HideAction'
import ResetCardAction from 'components/CardActions/actions/ResetAction'
import ArchiveCardAction from 'components/CardActions/actions/ArchiveAction'
import RequestSize from 'components/ProfileCard/components/RequestSize'
import Deadline from 'components/Deadlines'

const PipelineCard = ({ opportunity, setCurrentlyDragging }) => {
  const { id, funder, requestSize } = opportunity
  const { funderPrograms, status } = funder
  const isCardUpdating = useSelector(selectIsCardUpdating)
  const isFunderDissolved = !!status ? status === 'dissolved' : false

  const { hasOngoingDeadline, closestDeadlineDate } = getNextDeadlinesFromPrograms(funderPrograms)
  const funderHasNoPrograms = funderPrograms ? funderPrograms.length === 0 : true

  const {
    color: cardColor,
    Icon,
    label,
    showDate
  } = getDeadlineState({
    deadlineDate: closestDeadlineDate,
    isOngoing: hasOngoingDeadline,
    hasNoPrograms: funderHasNoPrograms,
    isFunderDissolved
  })

  const deadlineLabel =
    hasOngoingDeadline && !closestDeadlineDate.isValid
      ? label
      : !!closestDeadlineDate && showDate && <Deadline format="short" date={closestDeadlineDate} />

  const [isDragging, setIsDragging] = useState(false)

  const ref = useRef(null)

  useEffect(() => {
    return draggable({
      element: ref.current,
      canDrag: () => !isCardUpdating,
      getInitialData: () => ({ id }),
      onDragStart: () => {
        setIsDragging(true)
        setCurrentlyDragging(true)
      },
      onDrop: () => {
        setIsDragging(false)
        setCurrentlyDragging(false)
      }
    })
  }, [id, isCardUpdating, setCurrentlyDragging])

  const className = `Pipeline__card ${cardColor} ${isDragging ? 'dragging' : ''} ${
    isCardUpdating ? 'disabled' : ''
  }`

  return (
    <div ref={ref} className={className}>
      <div className="row">
        <Link to={`${PROFILE_PAGE}/${funder.id}`} draggable={false}>
          <Truncate lines={2}>{funder.name}</Truncate>
        </Link>
        <CardActions
          opportunityId={id}
          actions={[ResetCardAction, ArchiveCardAction, HideCardAction]}
          loadData={() => getPipelines(false)}
        />
      </div>
      <div className="row">
        {requestSize ? <RequestSize opportunity={opportunity} hideLabel={true} /> : <div />}
        <div className="Pipeline__card-deadline">
          {!!Icon && <Icon />}
          {deadlineLabel}
        </div>
      </div>
    </div>
  )
}

export default PipelineCard
